 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"draws/draw-onboarding-welcome-svg":"draws/draw-onboarding-welcome-svg","icons/icon-account-svg":"icons/icon-account-svg","icons/icon-charges-svg":"icons/icon-charges-svg","icons/icon-check-svg":"icons/icon-check-svg","icons/icon-circle-dot-svg":"icons/icon-circle-dot-svg","icons/icon-circle-svg":"icons/icon-circle-svg","icons/icon-client-svg":"icons/icon-client-svg","icons/icon-close-svg":"icons/icon-close-svg","icons/icon-configuration-svg":"icons/icon-configuration-svg","icons/icon-copy-svg":"icons/icon-copy-svg","icons/icon-cred-card-svg":"icons/icon-cred-card-svg","icons/icon-customers-svg":"icons/icon-customers-svg","icons/icon-dashboard-svg":"icons/icon-dashboard-svg","icons/icon-developer-svg":"icons/icon-developer-svg","icons/icon-direction-svg":"icons/icon-direction-svg","icons/icon-download-svg":"icons/icon-download-svg","icons/icon-edit-svg":"icons/icon-edit-svg","icons/icon-ellipsis-svg":"icons/icon-ellipsis-svg","icons/icon-fees-svg":"icons/icon-fees-svg","icons/icon-freearea-svg":"icons/icon-freearea-svg","icons/icon-hub-svg":"icons/icon-hub-svg","icons/icon-info-svg":"icons/icon-info-svg","icons/icon-invites-svg":"icons/icon-invites-svg","icons/icon-invoices-svg":"icons/icon-invoices-svg","icons/icon-learn-more-svg":"icons/icon-learn-more-svg","icons/icon-logoJPM-svg":"icons/icon-logoJPM-svg","icons/icon-logs-svg":"icons/icon-logs-svg","icons/icon-merchant-svg":"icons/icon-merchant-svg","icons/icon-mundi-svg":"icons/icon-mundi-svg","icons/icon-no-results-svg":"icons/icon-no-results-svg","icons/icon-notification-svg":"icons/icon-notification-svg","icons/icon-orders-svg":"icons/icon-orders-svg","icons/icon-pagarme-svg":"icons/icon-pagarme-svg","icons/icon-payment-links-svg":"icons/icon-payment-links-svg","icons/icon-payments-svg":"icons/icon-payments-svg","icons/icon-permission-svg":"icons/icon-permission-svg","icons/icon-pix-outline-svg":"icons/icon-pix-outline-svg","icons/icon-pix-svg":"icons/icon-pix-svg","icons/icon-plans-svg":"icons/icon-plans-svg","icons/icon-pos-svg":"icons/icon-pos-svg","icons/icon-profile-svg":"icons/icon-profile-svg","icons/icon-recurrence-svg":"icons/icon-recurrence-svg","icons/icon-security-svg":"icons/icon-security-svg","icons/icon-shop-svg":"icons/icon-shop-svg","icons/icon-statistics-svg":"icons/icon-statistics-svg","icons/icon-subscription-svg":"icons/icon-subscription-svg","icons/icon-subscriptions-svg":"icons/icon-subscriptions-svg","icons/icon-test-svg":"icons/icon-test-svg","icons/icon-trf-svg":"icons/icon-trf-svg","icons/icon-users-solid-svg":"icons/icon-users-solid-svg","icons/icon-users-svg":"icons/icon-users-svg","icons/icon-webhooks-config-svg":"icons/icon-webhooks-config-svg","icons/icon-webhooks-skeleton-svg":"icons/icon-webhooks-skeleton-svg","icons/icon-webhooks-svg":"icons/icon-webhooks-svg","logo/pagarme":"logo/pagarme"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/shop/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
